// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1tWEn","label":"SetPasswdForm_label__2kyb2"};